// frontend/src/components/cash-close/VarianceTableCompact.js
import React from 'react';
import { useTheme, sans, mono } from '../../tokens';
import VarianceCell from './VarianceCell';

const monthLabel = (ym) => {
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'short' });
};

export default function VarianceTableCompact({ rows, currency, fxRate, selectedMonth, onCellClick, expandedCell, drilldownRenderer, commentary }) {
  const t = useTheme();
  if (!rows.length) return null;
  const monthHeaders = rows[0].cells.map(c => c.month);

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: sans, fontSize: 11 }}>
      <thead>
        <tr style={{ borderBottom: `1px solid ${t.border}` }}>
          <th style={{ textAlign: 'left', padding: '8px 6px', fontSize: 10, fontWeight: 600, color: t.textMuted, textTransform: 'uppercase', letterSpacing: 0.5 }}>Department</th>
          {monthHeaders.map(m => (
            <th key={m} style={{ textAlign: 'center', padding: '8px 6px', fontSize: 10, fontWeight: 600, color: m === selectedMonth ? t.textPrimary : t.textMuted, textTransform: 'uppercase' }}>{monthLabel(m)}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map(({ dept, cells }) => (
          <React.Fragment key={dept}>
            <tr style={{ borderBottom: `1px solid ${t.borderLight}` }}>
              <td style={{ padding: '6px', color: t.textPrimary, fontWeight: 500 }}>{dept}</td>
              {cells.map(c => {
                const expanded = expandedCell?.dept === dept && expandedCell?.month === c.month;
                return (
                  <td key={c.month} style={{ padding: 0, border: expanded ? `1px solid ${t.borderMedium}` : 'none' }}>
                    <VarianceCell
                      cell={c}
                      currency={currency}
                      fxRate={fxRate}
                      isSelected={c.month === selectedMonth}
                      hasNote={!!commentary?.[`${dept}::${c.month}`]?.comment}
                      onClick={() => onCellClick(dept, c.month)}
                    />
                  </td>
                );
              })}
            </tr>
            {expandedCell?.dept === dept && (
              <tr><td colSpan={1 + cells.length} style={{ padding: 0 }}>{drilldownRenderer(dept, expandedCell.month)}</td></tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
}
